<template>
  <div>
    <div class="choose f-16 b-r-10 m-l-5 m-r-5 p-l-10 p-r-10">
      <dl class="m-l-5">
        <!-- <div v-if="item.level==3" class="flex p-t-20">
          <van-image radius="5" :src="global.getFilePath(item.picUrl)" />
          <h3>
            {{ item.name }}
            <small>1201</small>
          </h3>
        </div> -->
        <dt class="p-t-5">
          选择
          <span>{{ this.fullName(item.level)}}</span>
        </dt>
        <div class="flex p-t-20 p-b-20 m-l--10 m-t--10">
          <dd v-for="node in item.children" :key="node.id"
              @click="$emit('call-func',[node.id,item.id,item])"
              :class="{'active':item.showId==node.id}">
            {{node.name}}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
import { NavBar, Icon, Image as VanImage } from "vant";

export default {
  name: "CarChoose",
  props: ["item"],
  components: {
    [NavBar.name]: NavBar,
    [VanImage.name]: VanImage,
    [Icon.name]: Icon
  },
  methods: {
    fullName(level) {
      let name = "";
      switch (level) {
        case 3:
          name = "车型";
          break;
        case 4:
          name = "年份";
          break;
        case 5:
          name = "排气量或电动";
          break;
        case 6:
          name = "发动机";
          break;
      }
      return name;
    }
  }
};
</script>
